module.exports = __webpack_public_path__ + "img/us-flag.b0083ed6.webp";